import { render, staticRenderFns } from "./DecisionReport.vue?vue&type=template&id=56f6ec80&scoped=true"
import script from "./DecisionReport.vue?vue&type=script&lang=js"
export * from "./DecisionReport.vue?vue&type=script&lang=js"
import style0 from "./DecisionReport.vue?vue&type=style&index=0&id=56f6ec80&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f6ec80",
  null
  
)

export default component.exports